import React from 'react';

import { createClassName } from 'utils/createClassName';

import './codeInputLayoutStyles.scss';

type Props = {
  theme: 'emailCode' | 'promoCode' | 'secretCode' | 'partnerCode';
  inputs: React.ReactNode;
  indicator: React.ReactNode;
};

export const CodeInputLayoutComponent: React.FC<Props> = (props) => {
  const { theme, inputs, indicator } = props;

  const createCodeInputLayoutClassName = createClassName('codeInputLayout');

  const wrapperClassName = createCodeInputLayoutClassName('wrapper', { theme });

  const inputsClassName = createCodeInputLayoutClassName('inputs', { theme });

  const indicatorClassName = createCodeInputLayoutClassName('indicator', {
    theme,
  });

  return (
    <div className={wrapperClassName}>
      <div className={inputsClassName}>{inputs}</div>
      <div className={indicatorClassName}>{indicator}</div>
    </div>
  );
};
